import React, { useState, useEffect } from 'react';

import Titulo from '@components/Titulo';

import { cajaPrincipalStyle } from '@styles/cajaPrincipal';
import { cajaContenedorStyle } from '@styles/cajaContenedor';
import { cajaContenedorPrimeroStyle } from '@styles/cajaContenedorPrimero';

function Resultados() {
  const [error, setError] = useState('');
  
  // Datos de prueba para las citas
  const [citas] = useState([
    {
      id: 1,
      servicio: "Consulta General",
      medico: "Dr. Juan Pérez",
      fecha: "2024-01-15",
      hora: "09:00"
    },
    {
      id: 2,
      servicio: "Cardiología",
      medico: "Dra. María González",
      fecha: "2024-01-16",
      hora: "10:30"
    },
    {
      id: 3,
      servicio: "Dermatología",
      medico: "Dr. Carlos Rodríguez",
      fecha: "2024-01-17",
      hora: "14:00"
    },
    {
      id: 4,
      servicio: "Pediatría",
      medico: "Dra. Ana López",
      fecha: "2024-01-18",
      hora: "11:15"
    },
    {
      id: 5,
      servicio: "Oftalmología",
      medico: "Dr. Roberto Silva",
      fecha: "2024-01-19",
      hora: "16:45"
    }
  ]);

  useEffect(() => {

  }, []);

  return (
    <div id="cajaPrincipal"
      style={cajaPrincipalStyle}
    >
      <Titulo titulo="Consulta de resultados" subtitulo=""></Titulo>

      {/* Div central */}
      <div style={cajaContenedorStyle}>
        {/* Primer div */}

        {/* Contenido del primer div */}
        <div style={cajaContenedorPrimeroStyle}>
          {/* Tabla de citas */}
          <div style={{
            width: '100%',
            backgroundColor: '#fff',
            borderRadius: '8px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            overflow: 'hidden'
          }}>
            {/* Encabezado de la tabla */}
            <div style={{
              display: 'grid',
              gridTemplateColumns: '2fr 2fr 1.5fr 1fr',
              gap: '1rem',
              padding: '1rem',
              backgroundColor: '#f8f9fa',
              fontWeight: 'bold',
              fontSize: '1.4vh',
              fontFamily: 'Inter',
              borderBottom: '1px solid #e9ecef'
            }}>
              <div>Servicio</div>
              <div>Médico</div>
              <div>Fecha</div>
              <div>Hora</div>
            </div>
            
            {/* Filas de datos */}
            {citas.map((cita) => (
              <div 
                key={cita.id}
                style={{
                  display: 'grid',
                  gridTemplateColumns: '2fr 2fr 1.5fr 1fr',
                  gap: '1rem',
                  padding: '1rem',
                  fontSize: '1.3vh',
                  fontFamily: 'Inter',
                  borderBottom: '1px solid #f1f3f4',
                  transition: 'background-color 0.2s',
                  cursor: 'pointer'
                }}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#f8f9fa'}
                onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
              >
                <div style={{ color: '#495057' }}>{cita.servicio}</div>
                <div style={{ color: '#495057' }}>{cita.medico}</div>
                <div style={{ color: '#6c757d' }}>{new Date(cita.fecha).toLocaleDateString('es-ES')}</div>
                <div style={{ color: '#6c757d', fontWeight: '500' }}>{cita.hora}</div>
              </div>
            ))}
          </div>
        </div>
        {/* Fin contenido del primer div */}

      </div>

      {/* Mensaje de error */}
      {error && (
        <div style={{
          marginTop: '2vh',
          marginLeft: '6vh',
          color: 'red',
          fontSize: '1.6vh',
          fontFamily: 'Inter'
        }}>
          {error}
        </div>
      )}

    </div>
  );
}
export default Resultados;
